module.exports = __webpack_public_path__ + "img/item_1.35940dfc.png";